import { useEffect } from 'react';
import { initializeHubSpotTracking } from '../utils/hubspotForms';

interface HubSpotTrackingProps {
  portalId: string;
}

const HubSpotTracking: React.FC<HubSpotTrackingProps> = ({ portalId }) => {
  useEffect(() => {
    // Check if HubSpot script is already loaded
    if (window.hbspt) {
      initializeHubSpotTracking();
      return;
    }

    // Create and load HubSpot tracking script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://js.hs-scripts.com/${portalId}.js`;
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'strict-origin-when-cross-origin';
    script.id = 'hs-script-loader';
    
    // Initialize tracking when script loads
    script.onload = () => {
      console.log('📡 HubSpot script loaded successfully');
      initializeHubSpotTracking();
    };

    script.onerror = () => {
      console.error('❌ Failed to load HubSpot script');
    };
    
    document.head.appendChild(script);

    return () => {
      // Cleanup if component unmounts
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [portalId]);

  return null; // This component doesn't render anything
};

export default HubSpotTracking;